import { Box, Typography, Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import { ReactNode } from "react";

interface Props {
  title: string;
  onAddFilter?: () => void;

  // Opcionales para personalizar botón
  actionLabel?: string;
  actionIcon?: ReactNode;
}

export default function DashboardHeader({
  title,
  onAddFilter,
  actionLabel = "Agregar",   // 👈 default
  actionIcon = <Add />,      // 👈 default
}: Props) {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        width: "100%",
        backgroundColor: "#fff",
        borderBottom: "0.8px solid #e7e7e7",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: { xs: "column", sm: "row" },
        gap: 2,
        py: 2,
        px: 4,
      }}
    >
      <Typography sx={{ fontSize: "15px" }} fontWeight="medium">
        {title}
      </Typography>

      {/* Botón solo si hay acción */}
      {onAddFilter && (
        <Button
          variant="contained"
          startIcon={actionIcon}
          onClick={onAddFilter}
          sx={{
            backgroundColor: "#000",
            textTransform: "none",
            fontSize: "12px",
            minHeight: 35,
            height: 35,
            px: 3,
            boxShadow: "none",
            borderRadius: "10px",
            "&:hover": {
              backgroundColor: "#222",
              boxShadow: "none",
            },
          }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}
